import React, { ReactNode, useState } from 'react'
import SidebarLink from './SidebarLink'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Menu, MenuList } from '@mui/material'

type SidebarPopupProps = {
  popupId: string
  open: boolean
  Icon: React.ElementType
  sidebarLinkText: string
  index: number | number[]
  children: (popupState: any) => ReactNode
}

const SidebarPopup = ({ popupId, open, Icon, sidebarLinkText, index, children }: SidebarPopupProps) => {
  const totalItems = Array.isArray(index) ? index.length : 1
  const [focusedItemIndex, setFocusedItemIndex] = useState(0)

  return (
    <PopupState variant="popover" popupId={popupId} parentPopupState={null}>
      {popupState => (
        <React.Fragment>
          <SidebarLink
            open={open}
            Icon={Icon}
            text={sidebarLinkText}
            index={index}
            standard
            {...bindTrigger(popupState)}
          />
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            transformOrigin={{
              horizontal: 0,
              vertical: 8,
            }}
            slotProps={{
              paper: {
                sx: {
                  px: 1,
                  ml: 3,
                  minWidth: 150
                },
              },
            }}
          >
            <MenuList
              sx={{ gap: 0.5, display: 'flex', flexDirection: 'column' }}
              autoFocusItem={false}
              onKeyDown={(event) => {
                if (event.key !== "Tab" || (event.shiftKey && focusedItemIndex === 0)) return
                if (event.key === "Tab" && event.shiftKey && focusedItemIndex > 0) {
                  setFocusedItemIndex(focusedItemIndex - 1) 
                  event.stopPropagation() 
                }
                else if (event.key === "Tab" && focusedItemIndex < totalItems) {
                  setFocusedItemIndex(focusedItemIndex + 1) 
                  event.stopPropagation() 
                }
                else if (event.key === "Tab" && focusedItemIndex === totalItems) {
                  setFocusedItemIndex(0) 
                }
              }}
            >
              {children(popupState)}
            </MenuList>
          </Menu>

        </React.Fragment>
      )}
    </PopupState>
  )
}

export default SidebarPopup
